import { render, staticRenderFns } from "./cash-collection-by-cashier-detail.vue?vue&type=template&id=52471a21&scoped=true&"
import script from "./cash-collection-by-cashier-detail.vue?vue&type=script&lang=js&"
export * from "./cash-collection-by-cashier-detail.vue?vue&type=script&lang=js&"
import style0 from "./cash-collection-by-cashier-detail.vue?vue&type=style&index=0&id=52471a21&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52471a21",
  null
  
)

export default component.exports